import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, ComponentSync, EditableDBItemV3, LL_H_C, LL_V_L, ModuleFE_Dialog } from '@nu-art/thunderstorm-frontend/index';
import { BadImplementationException, ThisShouldNotHappenException } from '@nu-art/ts-common';
import { cleanItem_Referencable } from '@app/hcs-shared/hcs-v2';
import { ModuleFE_Referencable } from '../ModuleFE_Referencable.js';
import { ICONS } from '@app/styles';
import './Dialog_ReferencableEditor.scss';
import { Editor_Referencable } from '../Editor_Referencable/Editor_Referencable.js';
import { DropDown_Referencable } from '../ui-components.js';
const dialogKey = 'dialog__referencable-editor';
export class Dialog_ReferencableEditor extends ComponentSync {
    static show = (props) => {
        if ('referencableId' in props && 'context' in props)
            throw new BadImplementationException('Should not be sending both context and referencable');
        const model = {
            dialogKey: dialogKey,
            closeOverlayOnClick: () => false,
            content: () => _jsx(Dialog_ReferencableEditor, { ...props })
        };
        ModuleFE_Dialog.show(model);
    };
    // ######################## Life Cycle ########################
    deriveStateFromProps(nextProps, state) {
        //If provided context, derive should not be creating an editable item
        if ('context' in nextProps)
            return state;
        const props = nextProps;
        //Context was not provided, meaning:
        // - We are editing an existing referencable (if referencableId was provided)
        // - We are creating a new referencable (if referencableId was not provided)
        const referencable = ModuleFE_Referencable.cache.unique(props.referencableId) ?? cleanItem_Referencable;
        state.editable = new EditableDBItemV3(referencable, ModuleFE_Referencable);
        return state;
    }
    // ######################## Logic ########################
    onQuery = async (referencable) => {
        referencable ??= cleanItem_Referencable;
        const editable = new EditableDBItemV3(referencable, ModuleFE_Referencable);
        if (!('context' in this.props) || !this.props.context)
            throw new ThisShouldNotHappenException('Not supposed to see the query page without context');
        //Push context into dbRefs
        const dbRefs = editable.editProp('dbRefs', []);
        dbRefs.updateArrayAt(this.props.context);
        //Upsert existing referencable
        if (editable.item._id)
            await editable.save();
        this.setState({ editable });
    };
    // ######################## Render ########################
    render() {
        return _jsxs(LL_V_L, { id: dialogKey, children: [this.render_Header(), this.render_Body()] });
    }
    render_Header = () => {
        return _jsxs(LL_H_C, { className: 'dialog__header', children: ["Referencable Editor", _jsx(ICONS.x.component, { onClick: () => ModuleFE_Dialog.close() })] });
    };
    render_Body = () => {
        if (this.state.editable)
            return _jsx(Editor_Referencable, { editable: this.state.editable });
        return this.render_Body_Query();
    };
    render_Body_Query = () => {
        return _jsxs(LL_V_L, { className: `${dialogKey}__query`, children: [_jsx(Button, { variant: 'text', onClick: () => this.onQuery(), children: "Create New Referencable" }), "OR", _jsx(DropDown_Referencable.selectable, { selected: undefined, placeholder: 'Connect Existing Referencable', onSelected: referencable => this.onQuery(referencable) })] });
    };
}
//# sourceMappingURL=Dialog_ReferencableEditor.js.map